import { useContext } from "react";
import { AutocompleteContext } from "../providers";

export function useAutocomplete() {
  return useContext(AutocompleteContext);
}
